import { createTransform } from "redux-persist";

// braie filter kardan kar roie dadeha moghe load unload estefade mishe az local storage

const SetTransformAuth = createTransform(
  (inboundState, key) => {
    // console.log('inbound',key,inboundState)
    return inboundState;
  },
  (outboundState, key) => {
    // console.log('outbound',key,outboundState)
    return {
      ...outboundState,
      loading: false,
      errors: null,
      openLogin: false,
      openRegister: false,
      openCellphoneVerification: false,
      verifySend: {
        loading: false,
        errors: null,
      },
      verification: {
        loading: false,
        errors: null,
      },
    };
  },
  // define which reducers this transform gets called for.
  { whitelist: ["auth"] },
);

export default SetTransformAuth;
